import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Colors } from "./styles/Colors";
import { Body, BodyStyles, Header5 } from "./typography";
import DownArrow from "../assets/icons/down-arrow.svg";
import { SUBS_ENABLED } from "../utils/settings";
import { formatDeliveryCadence } from "../utils/Prive";
const Wrapper = styled.div`
  border-top: ${Colors.webGrey} 1px solid;
  padding: 8px 0 0;
`;

const Button = styled.button`
  width: 23px;
  height: 23px;

  background: ${(props) => (props.selected ? Colors.white : "transparent")};

  border-radius: 50%;
  border: 0;
  outline: none;

  cursor: pointer;

  box-shadow: ${(props) =>
    props.selected
      ? `inset 0px 0px 0px 7px ${Colors.hunter}`
      : `inset 0px 0px 0px 3px ${Colors.webGrey}`};

  &:hover,
  &:focus {
    background: ${(props) =>
    !props.selected ? Colors.webGrey : "transparent"};
  }
`;

const RadioOptionWrapper = styled.div`
  display: flex;

  margin: 32px 0;

  > ${Button} {
    position: relative;
    bottom: 3px;

    margin-right: 16px;
  }

  > div:first-of-type {
    flex: 1;

    display: flex;
    justify-content: space-between;

    > div:nth-child(2) {
      text-align: right;
    }
  }
`;

const Select = styled.select`
  border: 0;
  outline: none;
  background : url('${DownArrow}') 94% / 14% no-repeat transparent;
  appearance: none;
  padding-right: 20px;

  ${BodyStyles}
`;

function RadioOption({
  variant,
  selected,
  subscription,
  duration,
  onSelect,
  onSelectDuration,
  options,
}) {

  return (
    <RadioOptionWrapper>
      <Button onClick={onSelect} selected={selected} />
      <div>
        <div>
          <Header5>{subscription ? "Subscribe" : "One-time order"}</Header5>
          {subscription && (
            <Body>
              Ship every:{" "}
              <Select value={duration} onChange={onSelectDuration}>
                {
                  options?.map((option) => <option key={option.sellingPlanId} value={option.sellingPlanId}>{`${formatDeliveryCadence(option.deliveryCadenceCount,option.deliveryCadenceUnit)}`}</option>)
                }
              </Select>
            </Body>
          )}
        </div>
        {selected && (
          <div>
            <Header5>
              {new Intl.NumberFormat(process.env.GATSBY_LOCALE, {
                style: "currency",
                currency: process.env.GATSBY_LOCALE === 'en-US' ? "USD" : "GBP",
              }).format(variant.price)}
            </Header5>
            {subscription && <Body>Saving 10%</Body>}
          </div>
        )}
      </div>
    </RadioOptionWrapper>
  );
}

export default function ProductSubscriptionRadio({
  selectedVariant,
  onSelectPurchaseType,
  onSelectDuration,
  options
}) {
  const canSubscribe = SUBS_ENABLED && !!selectedVariant.subscription;
 
  const [selected, setSelected] = useState(canSubscribe ? 0 : 1);
  const [duration, setDuration] = useState(); // months

  useEffect(() => {
    if (!options) setDuration(null);
    else setDuration(options?.find(option => option.deliveryCadenceCount === 3)?.sellingPlanId || options[0]?.sellingPlanId || null);
  },[options])
  

  function changeSelection(index) {
    setSelected(index);

    if (onSelectPurchaseType) {
      onSelectPurchaseType(index ? "ONE_TIME" : "SUBSCRIPTION");
    }
  }

  function changeDuration(e) {
    setDuration(e.target.value);
    setSelected(0);

    if (onSelectDuration) {
      onSelectDuration(e.target.value);
    }
  }

  return (
    <Wrapper>
      {canSubscribe && (
        <RadioOption
          variant={selectedVariant.subscription}
          selected={selected === 0}
          duration={duration}
          onSelect={() => changeSelection(0)}
          onSelectDuration={changeDuration}
          subscription
          options={options}
        />
      )}
      <RadioOption
        variant={selectedVariant.individual}
        selected={selected === 1 || !canSubscribe}
        onSelect={() => changeSelection(canSubscribe ? 1 : 0)}
      />
    </Wrapper>
  );
}
